<style scoped>

</style>

<template>
    <div>
        <h1>道具管理</h1>
    </div>
</template>

<script>
export default {
    name: 'User'
}
</script>



// WEBPACK FOOTER //
// src/page/toolManage.vue